module.exports = __webpack_public_path__ + "static/media/mercadoLibre.f01e2cf4.png";